import React, { useState } from 'react'
import { css } from '@emotion/core'
import { Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import { Button, ButtonType } from '@/components/atoms/button'
import { ReservationTaskHandlingStatus } from '@/models/reservation/reservation-task'
import { HANDLING_STATUS_POPOVER_CLASS, HandlingStatusMenu } from './handling-status-menu'

type Props = {
  disabled: boolean
  onSelect: (status: ReservationTaskHandlingStatus) => void
}

export const BulkHandlingStatusButton: React.FC<Props> = ({ disabled, onSelect }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  // Button は isDisabled を渡しても見た目が変わらないため、無効のときは buttonType で見た目を変える
  const button = (
    <Button
      buttonType={disabled ? ButtonType.BorderDisabled : ButtonType.Secondary}
      isDisabled={disabled}
      width={148}
      height={32}
      fontSize={12}
      marginLeft={16}
    >
      {t('reservationTask.BulkStatusChange')}
      <img src={require('@/static/images/arrow_down_yellow.svg')} alt="" css={arrowStyle} />
    </Button>
  )
  if (disabled) {
    return button
  }

  return (
    <Popover
      overlayClassName={HANDLING_STATUS_POPOVER_CLASS}
      placement="bottomLeft"
      trigger="click"
      visible={isOpen}
      onVisibleChange={setIsOpen}
      destroyTooltipOnHide
      content={
        <HandlingStatusMenu
          onSelect={status => {
            setIsOpen(false)
            onSelect(status)
          }}
        />
      }
    >
      {button}
    </Popover>
  )
}

const arrowStyle = css({
  marginLeft: 8,
})
